import Vue from "vue";
import Router from "vue-router";
import firebase from "firebase/app";
import "firebase/auth";
import store from "./store/index";
// public and admin routers path
import routerPaths from "@/router/index";

Vue.use(Router);

const router = new Router({
  mode: "history",
  base: "/",
  routes: [...routerPaths]
});

router.beforeEach((to, from, next) => {
  const currentUser = firebase.auth().currentUser;
  const requiresAuth = to.matched.some(x => x.meta.requiresAuth);
  const owner = to.matched.some(x => x.meta.owner);

  if (owner && requiresAuth) {
    if (!store.state.userProfile.roles) {
      next("/admin");
      return;
    } else if (!store.state.userProfile.roles.includes("OWNER")) {
      next("/admin");
      return;
    }
  }

  if (requiresAuth && !currentUser) {
    next("/admin");
  } else if (requiresAuth && currentUser) {
    next();
  } else {
    next();
  }
});

export default router;
